
import {motion} from 'framer-motion'
import {baseurl, getProducts, getSplash} from '../../services/services'



import {EventCard} from '../index'
import {LinearProgress} from "@mui/material";

import {useState,useEffect} from 'react'
import {Link} from 'react-router-dom'



const Midbox = () => {




    const [dataNeeded, setData]=useState(false)
    const getdata = async ()=>{

        const options = {


            params: { take: 4}
        };
        const res = await getProducts()
        if (res && res.data.code == 1) {
            console.log(res.data)

            setData(res.data)
        } else {
            alert('مشکل در ارتباط با سرور')
        }
    }

    useEffect(() => {
        getdata().then()

    }, []);







    let content
    if (dataNeeded!==false) {



        if (dataNeeded.items.length > 0) {

            content = dataNeeded.items.map((item) => (


                <EventCard key={item.id} image={`${baseurl}/${item.image}`} id={item.id}
                             title={item.title}
                           price={item.price}


                           />

            ))
        } else {
            content = <div className='column is-12'>
                <p className='yekan has-text-centered is-size-4-desktop'>
                    در شهر انتخاب شده برنامه ای جهت نمایش وجود ندارد.
                </p>
            </div>
        }


    } else {
        content = <div className='column is-12'>
            <LinearProgress variant='indeterminate' color='primary' sx={{
                '&.MuiLinearProgress-root':{
                    backgroundColor:'#0002A6'
                }

            }}/>
        </div>
    }

    return (
        <>
            <section>


                <div className='columns mx-0  is-multiline navpadend150 navpadstart150 my-6 '>
                    <div className='column is-12 is-relative'>

                        <div className='column is-12 mb-6'>



                                <h2 className='is-size-4-mobile is-size-2-desktop kook has-text-weight-bold has-text-white has-text-centered  '>
                                    جدید ترین محصولات  بازرکانی قاسمی
                                </h2>

                        </div>


                        <div className='columns'>
                            <div className='column  is-12 '>
                                <motion.div className='columns is-flex is-multiline' initial='hidden' animate='visible'
                                            variants={{
                                                visible: {
                                                    opacity: 1,
                                                    scale: 1,
                                                    transition: {
                                                        delayChildren: 0.2,
                                                        staggerChildren: 0.3,
                                                        duration: 0.963

                                                    },
                                                },
                                                hidden: {
                                                    opacity: 1, scale: 0

                                                },
                                            }}>


                                    {content}


                                </motion.div>


                            </div>
                        </div>


                    </div>


                    <div className='column is-12 has-text-centered mt-5'>

                        <Link to={'/products'}>
                            <button

                                className='button mybutton is-align-self-flex-end px-6 mx-auto   kook  noborder  has-text-weight-bold '
                                style={{borderRadius: '0.6rem'}}>
                                مشاهده بیشتر
                            </button>
                        </Link>



                    </div>


                </div>
            </section>

        </>
    )
}
export default Midbox